import React from 'react';
import { Modal } from 'react-bootstrap-v5';
import CreateOperation from '../../finance/components/create';

type Props = {
  show: boolean;
  handleClose: () => void;
};

export const PaymentReceiveModal: React.FC<Props> = ({ show, handleClose }) => {
  return (
    <Modal
      className="modal fade"
      id="kt_payment_receive_modal"
      data-backdrop="static"
      tabIndex={-1}
      role="dialog"
      show={show}
      dialogClassName="modal-xl"
      aria-hidden="true"
      onHide={handleClose}
    >
      <div className="modal-body">
        <CreateOperation />
      </div>
    </Modal>
  );
};
